import React from 'react';

import SvgIcon from '@twicapp/ui/components/SvgIcon';

import { ReactComponent as WalletSvg } from '@twicapp/ui/icons/wallet.svg';
import { ReactComponent as WellnessSvg } from '@twicapp/ui/icons/store-wellness.svg';
import { ReactComponent as FamilySvg } from '@twicapp/ui/icons/baby.svg';
import { ReactComponent as RewardSvg } from '@twicapp/ui/icons/star.svg';
import { ReactComponent as PetSvg } from '@twicapp/ui/icons/store-pet.svg';
import { ReactComponent as CommunicationSvg } from '@twicapp/ui/icons/mobile.svg';
import { ReactComponent as CommuterSvg } from '@twicapp/ui/icons/commuter.svg';

import { TWIC_ACCOUNT_TYPES } from 'constants/accounts';

const WalletTypeIcon = ({ wallet_type_id, size, stroke }: $TSFixMe) => {
  switch (wallet_type_id) {
    case TWIC_ACCOUNT_TYPES.WELLNESS:
      return <SvgIcon size={size} icon={WellnessSvg} stroke={stroke} />;
    case TWIC_ACCOUNT_TYPES.FAMILY:
      return <SvgIcon size={size} icon={FamilySvg} stroke={stroke} />;
    case TWIC_ACCOUNT_TYPES.REWARDS:
      return <SvgIcon size={size} icon={RewardSvg} stroke={stroke} />;
    case TWIC_ACCOUNT_TYPES.PET:
      return <SvgIcon size={size} icon={PetSvg} stroke={stroke} />;
    case TWIC_ACCOUNT_TYPES.COMMUNICATIONS:
      return <SvgIcon size={size} icon={CommunicationSvg} stroke={stroke} />;
    case TWIC_ACCOUNT_TYPES.COMMUTER:
      return <SvgIcon size={size} icon={CommuterSvg} stroke={stroke} />;
    default:
      return <SvgIcon size={size} icon={WalletSvg} stroke={stroke} />;
  }
};
export default WalletTypeIcon;
